import { useState, useEffect, useMemo } from "react";
import { useData } from "../../../context/DataContext";
import { useNavigate } from 'react-router-dom';
import { createAdOption } from "../../../context/createAPI";
import {
    Card, CardContent,
    CardActions,
    Grid,
    FormControl,
    FormLabel,
    FormControlLabel,
    Checkbox,
    Radio,
    TextField, Typography, CardHeader,
    Box, Divider,
} from "@mui/material";
import CustomButton from "../../../components/buttons/customButton";
import SingleSelect from "../../../components/Selections/singleSelect";
import SnackbarMessage from "../../../components/snackBar/snackBar";
import { getClientTheme } from "../../../theme/clientTheme";

function AdOptionCreation() {
    const navigate = useNavigate();
    const { user = {}, villageGroups = [], farmers = [], years = [], handleAdOption, adOptionData = [], user_client_id } = useData();
    const yearIndex = years[0]?.value;
    const clientTheme = getClientTheme(user_client_id);
    const [searchText, setSearchText] = useState("");
    const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });

    const ffGroupData = villageGroups.filter((item) => item.level_id === 4);
    const groupsArray = ffGroupData[0]?.data.filter(item => item.group_id !== "").map((item) => ({ value: item.group_id, label: item.Groups }));
    const villagesArray = ffGroupData[0]?.data.filter((item) => item.village_id !== "").map((item) => ({ value: item.village_id, label: item.village }));
    const filteredData = farmers.filter(farmer => !adOptionData.some(ad => ad.farmer_id === farmer.id));


    const [state, setState] = useState({
        irrigation: { value: 1, type: "radio" },
        total_growing_farmers: { value: 1, type: "radio" },
        cropRotation: { value: 1, type: "radio" },
        application_fertilzers_4R_method: { value: 1, type: "radio" },
        summerDeepPloughing: { value: 1, type: "radio" },
        InterCrop: { value: 1, type: "radio" },
        borderandTrapcrop: { value: 1, type: "radio" },
        soilTestFertilizer: { value: 1, type: "radio" },
        selectionQualitySeed: { value: 1, type: "radio" },
        navadanyaCultivationasgreenmanure: { value: 1, type: "radio" },
        wasteDecomposer: { value: 1, type: "radio" },
        avoidTopdressingofComplexfertilizers: { value: 1, type: "radio" },

        cityCompost: { value: 0, type: "checkbox" },
        vermiCompost: { value: 0, type: "checkbox" },
        FYMValue: { value: 0, type: "checkbox" },
        tankSilt: { value: 0, type: "checkbox" },
        sheep_penning: { value: 0, type: "checkbox" },

        avoid_chemicalsprayup45days: { value: 0, type: "checkbox" },

        foliarSprayofNutrients: { value: 1, type: "radio" },

        selectedNeemValue: { value: 0, type: "checkbox" },
        selectedVitexValue: { value: 0, type: "checkbox" },

        pheromone: { value: 0, type: "checkbox" },
        cremitgel: { value: 0, type: "checkbox" },
        lightTraps: { value: 0, type: "checkbox" },
        sticky: { value: 0, type: "checkbox" },

        usingofTraichogrammaCards: { value: 1, type: "radio" },
        stemApplication: { value: 0, type: "checkbox" },
        regularFieldbservations: { value: 0, type: "checkbox" },
        eTLlevelBasedApplication: { value: 0, type: "checkbox" },

        alternate: { value: 0, type: "checkbox" },
        criticalGrowthStageIrrigation: { value: 0, type: "checkbox" },
        selectedDrip: { value: 0, type: "checkbox" },

        avoidRepititionofSamepesticides: { value: 1, type: "radio" },

        fullbodyCoveringDress: { value: 0, type: "checkbox" },
        selectedDootsAndshoes: { value: 0, type: "checkbox" },
        selectedMaks: { value: 0, type: "checkbox" },
        selectedGogglesAndHelmet: { value: 0, type: "checkbox" },
        selectedFullPPE: { value: 0, type: "checkbox" },
        selectedGloves: { value: 0, type: "checkbox" },


        properDisposalOfChemicalContainers: { value: 1, type: "radio" },
        applicationEquipement: { value: 1, type: "radio" },

        appropriate_PPE: { value: 1, type: "radio" },
        avoidChemicalSprayupto45Days: { value: 1, type: "radio" },

        trichoderma: { value: 0, type: "checkbox" }, pseudomonas: { value: 0, type: "checkbox" }, beaveriaBassiana: { value: 0, type: "checkbox" },

        removalofrosetteflowers: { value: 0, type: "checkbox" }, avoidContamination: { value: 0, type: "checkbox" }, avoidPolyPropyleneBags: { value: 0, type: "checkbox" },
        useOfNanoUrea: { value: 0, type: "checkbox" }, useOfNanoUreaPotash: { value: 0, type: "checkbox" }, biochar: { value: 0, type: "checkbox" }, cropresidueManagement: { value: 0, type: "checkbox" }, reduceInterculturalOperationsAwarenessonthechildLabour: { value: 0, type: "checkbox" }, awarenessonMinimumwages: { value: 0, type: "checkbox" },
        maintainanceOfFFBs: { value: 0, type: "checkbox" }, ploughAcrossTheslope: { value: 0, type: "checkbox" }, biofertilizer: { value: 0, type: "checkbox" },
        foodSpray: { value: 0, type: "checkbox" },
        cottonGradingSafeStorage: { value: 0, type: "checkbox" },
        minimumWages: { value: 0, type: "checkbox" },
        avoidChildLabour: { value: 0, type: "checkbox" },
        awarenessOnTheChildLabour: { value: 0, type: "checkbox" },

        agniAstra: { value: 0, type: "checkbox" }, neemAstra: { value: 0, type: "checkbox" }, dashaparnikashayam: { value: 0, type: "checkbox" }, vermiWash: { value: 0, type: "checkbox" },
        usingOfCocktailsByFarmers: { value: 1, type: "radio" },
        codeOfpesticides: { value: 1, type: "radio" },
        pesticidesprayingTechniques: { value: 1, type: "radio" },


        panGroupPesticides: { value: 1, type: "radio" },

        monocrotophos: { value: 0, type: "checkbox" }, lambdaCyhalothrin: { value: 0, type: "checkbox" }, carbendazim: { value: 0, type: "checkbox" }, propiconazole: { value: 0, type: "checkbox" }, bifenthrin: { value: 0, type: "checkbox" },

        selectedGroupValue: "",
        selectedGroupValueError: "",
        selectedVillageValue: "",
        selectedVillageValueError: "",
        seleectedFarmerValue: "",
        seleectedFarmerValueError: "",
        selectedYearValue: yearIndex,
        villageAndGroupWiseFarmerData: [],
        loading: false,
        responseMessage: "",
    });




    useEffect(() => {
        if (years?.length > 0) {
            setState(prevState => ({ ...prevState, selectedYearValue: years[0].value }))
        }
    }, [years]);

    const AdOptionCreationFields = [
        {
            title: false,
            fields: [
                { value: 1, label: "Irrigation", type: "radio", name: "irrigation" },
                { value: 2, label: "Total growing farmers", type: "radio", name: "total_growing_farmers" },

                { value: 3, label: "Crop Rotation", type: "radio", name: "cropRotation" },
                { value: 4, label: "Summer deep ploughing once in 2-3 Years", type: "radio", name: "summerDeepPloughing" },
                { value: 5, label: "Inter crop/Cover crop", type: "radio", name: "InterCrop" },
                { value: 6, label: "border and Trap crop", type: "radio", name: "borderandTrapcrop" },

                { value: 7, label: "soil test based fertilizer application", type: "radio", name: "soilTestFertilizer" },
                { value: 8, label: "Application fertilzers in 4R's method", type: "radio", name: "application_fertilzers_4R_method" },
                { value: 9, label: "Selection of Quality seed", type: "radio", name: "selectionQualitySeed" },
                { value: 10, label: "Navadanya Cultivation as green manure", type: "radio", name: "navadanyaCultivationasgreenmanure" },
                { value: 11, label: "Waste Decomposer", type: "radio", name: "wasteDecomposer" },

                { value: 12, label: "Avoid Top dressing of Complex fertilizers", type: "radio", name: "avoidTopdressingofComplexfertilizers" },
            ],
            footer: false,
        }, {
            title: true,
            titleData: "organic mannure application",
            fields: [
                { value: 1, label: "Vermi compost", type: "checkbox", name: "vermiCompost" },
                { value: 2, label: "Choose FYM", type: "checkbox", name: "FYMValue" },
                { value: 3, label: "Choose Tank Silt", type: "checkbox", name: "tankSilt" },
                { value: 4, label: "Choose Sheep Penning", type: "checkbox", name: "sheep_penning" },
                // { value: 4, label: "city compost", type: "checkbox", name: "cityCompost" },

            ],
            footer: true,
            footerData: [{ value: 1, label: "foliar spray of nutrients", type: "radio", name: "foliarSprayofNutrients" }],
        }, {
            title: true,
            titleData: "Botanical Extracts",
            fields: [
                { value: 1, label: "Choose Neem", type: "checkbox", name: "selectedNeemValue" },
                { value: 2, label: "Choose Vitex", type: "checkbox", name: "selectedVitexValue" }
            ],
            footer: false,
        },
        {
            title: true,
            titleData: "Traps",
            fields: [
                { value: 1, label: "Choose pheromone", type: "checkbox", name: "pheromone" },
                { value: 2, label: "Choose cremit gel", type: "checkbox", name: "cremitgel" },
                { value: 3, label: "Choose light Traps", type: "checkbox", name: "lightTraps" },
                { value: 4, label: "Choose sticky cards", type: "checkbox", name: "sticky" },
            ],
            footer: false,
        }, {
            title: false,
            fields: [
                { value: 1, label: "stem application", type: "checkbox", name: "stemApplication" },
                { value: 2, label: "Regular Field bservations", type: "checkbox", name: "regularFieldbservations" },
                { value: 3, label: "Avoid chemical spray up to 45 days", type: "checkbox", name: "avoid_chemicalsprayup45days" },
                { value: 4, label: "ETL level based application", type: "checkbox", name: "eTLlevelBasedApplication" },
            ],
            footer: false,
        }, {
            title: true,
            titleData: "Irrigation Method",
            fields: [
                { value: 1, label: "Alternate", type: "checkbox", name: "alternate" },
                { value: 2, label: "Critical growth stage irrigation", type: "checkbox", name: "criticalGrowthStageIrrigation" },
                { value: 3, label: "Choose Drip", type: "checkbox", name: "selectedDrip" },
            ],
            footer: true,
            footerData: [{ value: 1, label: "Avoid Repitition of Same pesticides", type: "radio", name: "avoidRepititionofSamepesticides" }],
        }, {
            title: true,
            titleData: "PPE",
            fields: [
                { value: 1, label: "Full body covering dress", type: "checkbox", name: "fullbodyCoveringDress" },
                { value: 2, label: "boots/shoes", type: "checkbox", name: "selectedDootsAndshoes" },
                { value: 3, label: "Mask", type: "checkbox", name: "selectedMaks" },

                { value: 4, label: "goggles/helmet", type: "checkbox", name: "selectedGogglesAndHelmet" },
                { value: 5, label: "gloves", type: "checkbox", name: "selectedGloves" },

                { value: 6, label: "Minimum PPE", type: "checkbox", name: "selectedFullPPE" }
            ],
            footer: true,
            footerData: [
                { value: 1, label: "Appropriate PPE", type: "radio", name: "appropriate_PPE" },
                { value: 2, label: "Proper disposal of chemical containers", type: "radio", name: "properDisposalOfChemicalContainers" },
                // { value: 3, label: "Avoid chemical spray up to 45 days", type: "radio", name: "avoidChemicalSprayupto45Days" }
                { value: 3, label: "Proper maintaine of pesticide application equipement", type: "radio", name: "applicationEquipement" },
                { value: 4, label: "Using of Traichogramma Cards", type: "radio", name: "usingofTraichogrammaCards" },

            ],
        }, {
            title: false,
            fields: [
                { value: 1, label: "reduce intercultural operations", type: "checkbox", name: "reduceInterculturalOperationsAwarenessonthechildLabour" },
                { value: 2, label: "Avoid the child labour", type: "checkbox", name: "avoidChildLabour" },
                { value: 3, label: "Awareness and providing  Minimum wages", type: "checkbox", name: "minimumWages" },
                { value: 4, label: "Maintainance of FFB's", type: "checkbox", name: "maintainanceOfFFBs" },
                { value: 5, label: "plough across the slope", type: "checkbox", name: "ploughAcrossTheslope" },
                { value: 6, label: "Using of Bio fertilizers", type: "checkbox", name: "biofertilizer" },
                { value: 7, label: "Use of Nano Urea", type: "checkbox", name: "useOfNanoUrea" },
                { value: 8, label: "Use of Neo/Nano Potash", type: "checkbox", name: "useOfNanoUreaPotash" },
                { value: 9, label: "Biochar", type: "checkbox", name: "biochar" },
                { value: 10, label: "Food Spray", type: "checkbox", name: "foodSpray" },
                { value: 11, label: "removal of rosette flowers", type: "checkbox", name: "removalofrosetteflowers" },
                { value: 12, label: "Avoid Contamination", type: "checkbox", name: "avoidContamination" },
                { value: 13, label: "Avoid PolyPropylene Bags", type: "checkbox", name: "avoidPolyPropyleneBags" },
                { value: 14, label: "Crop residue management", type: "checkbox", name: "cropresidueManagement" },
                { value: 15, label: "Cotton Grading and Safe storage", type: "checkbox", name: "cottonGradingSafeStorage" },

                // { value: 5, label: "Use of Neo/Nano Potash", type: "checkbox", name: "useOfNanoUreaPotash" },
                // { value: 6, label: "Biochar", type: "checkbox", name: "biochar" },
                // { value: 8, label: "reduce intercultural operations", type: "checkbox", name: "reduceInterculturalOperationsAwarenessonthechildLabour" },
                // { value: 9, label: "Awareness on Minimum wages", type: "checkbox", name: "awarenessonMinimumwages" },
                // { value: 10, label: "Awareness on the child labour", type: "checkbox", name: "awarenessOnTheChildLabour" },
            ],
            footer: false,
        }, {
            title: true,
            titleData: "Using of Bio pesticides",
            fields: [
                { value: 1, label: "Trichoderma", type: "checkbox", name: "trichoderma" },
                // { value: 2, label: "Pseudomonas", type: "checkbox", name: "pseudomonas" },
                { value: 3, label: "Beaveria bassiana", type: "checkbox", name: "beaveriaBassiana" },
            ],
            footer: false,
        }, {
            title: true,
            titleData: "Usage of Organic pesticides",
            fields: [
                { value: 1, label: "Agni astra", type: "checkbox", name: "agniAstra" },
                { value: 2, label: "Neem astra", type: "checkbox", name: "neemAstra" },
                { value: 3, label: "Dashaparni kashayam", type: "checkbox", name: "dashaparnikashayam" },
                { value: 4, label: "Vermi wash", type: "checkbox", name: "vermiWash" },
            ],
            footer: true,
            footerData: [
                { value: 1, label: "Using of Cocktails by farmers", type: "radio", name: "usingOfCocktailsByFarmers" },
                { value: 2, label: "Minimize the use of PAN group 3 Pesticides", type: "radio", name: "panGroupPesticides" },
            ],
        }, {
            title: true,
            titleData: "Using of HHP's by farmers",
            fields: [
                { value: 1, label: "Monocrotophos", type: "checkbox", name: "monocrotophos" },
                { value: 2, label: "Lambda cyhalothrin", type: "checkbox", name: "lambdaCyhalothrin" },
                { value: 3, label: "Carbendazim", type: "checkbox", name: "carbendazim" },
                { value: 4, label: "Propiconazole", type: "checkbox", name: "propiconazole" },
                { value: 5, label: "Bifenthrin", type: "checkbox", name: "bifenthrin" },
            ],
            footer: true,
            footerData: [
                { value: 1, label: "Knowledge on  colour codes of pesticides", type: "radio", name: "codeOfpesticides" },
                { value: 2, label: "Received any training on pesticide spraying techniques", type: "radio", name: "pesticidesprayingTechniques" },
            ],
        }
    ];

    const handleChange = (event) => {
        const { name, type, checked, value } = event.target;
        const newValue = type === "checkbox" ? (checked ? 1 : 0) : parseInt(value, 10);
        // setState(prevState => ({
        //     ...prevState,
        //     [name]: newValue,
        // }));

        setState(prevState => ({
            ...prevState,
            [name]: {
                value: newValue,
                type: type
            }
        }));
        setSearchText("");
    };

    const options = [
        { label: "Yes", value: 1 },
        { label: "No", value: 0 },
    ];

    const handleInputChange = (name, value) => {
        if (name === "selectedVillageValue") {
            const villageFarmers = filteredData.filter((item) => item.village_id.toString() === value).map((item) => ({ label: `${item.farmer_name} - (${item.relative_name})`, value: item.id }));
            setState(prevState => ({
                ...prevState,
                selectedVillageValue: value,
                villageAndGroupWiseFarmerData: villageFarmers,
                selectedVillageValueError: "",
                seleectedFarmerValue: "",
            }))
        } else if (name === "selectedGroupValue") {
            const groupFarmers = filteredData.filter((item) => item.ff_group_id.toString() === value).map((item) => ({ label: `${item.farmer_name} - (${item.relative_name})`, value: item.id }));
            setState(prevState => ({
                ...prevState,
                selectedGroupValue: value,
                villageAndGroupWiseFarmerData: groupFarmers,
                selectedGroupValueError: "",
                seleectedFarmerValue: "",
            }))
        } else if (name === "seleectedFarmerValue") {
            setState(prevState => ({
                ...prevState,
                seleectedFarmerValue: value,
                seleectedFarmerValueError: ""
            }))
        } else if (name === "selectedYearValue") {
            setState(prevState => ({
                ...prevState,
                selectedYearValue: value,
            }))
        }
    };

    const handleSubmit = async (e) => {

        e.preventDefault();
        const { selectedVillageValue, seleectedFarmerValue, selectedGroupValue } = state;

        if (user?.level_id === 1) {
            if (selectedVillageValue === "") {
                setState(prevState => ({ ...prevState, selectedVillageValueError: "Please Select Village" }));
                return;
            }
        } else {
            if (selectedGroupValue === "") {
                setState(prevState => ({ ...prevState, selectedGroupValueError: "Please Select Groups" }));
                return;
            }
        }

        if (seleectedFarmerValue === "") {
            setState(prevState => ({ ...prevState, seleectedFarmerValueError: "Please Select Farmer" }));
            return;
        }

        const stateDetails = [{
            "irrigation": state.irrigation, "total_growing_farmers": state.total_growing_farmers, "application_fertilzers_4R_method": state.application_fertilzers_4R_method,
            "cropRotation": state.cropRotation, "summerDeepPloughing": state.summerDeepPloughing, "InterCrop": state.InterCrop,
            "borderandTrapcrop": state.borderandTrapcrop, "soilTestFertilizer": state.soilTestFertilizer, "selectionQualitySeed": state.selectionQualitySeed,
            "navadanyaCultivationasgreenmanure": state.navadanyaCultivationasgreenmanure, "wasteDecomposer": state.wasteDecomposer,
            "avoidTopdressingofComplexfertilizers": state.avoidTopdressingofComplexfertilizers, "cityCompost": state.cityCompost,
            "vermiCompost": state.vermiCompost, "FYMValue": state.FYMValue, "tankSilt": state.tankSilt, "sheep_penning": state.sheep_penning, "avoid_chemicalsprayup45days": state.avoid_chemicalsprayup45days,
            "foliarSprayofNutrients": state.foliarSprayofNutrients, "selectedNeemValue": state.selectedNeemValue, "selectedVitexValue": state.selectedVitexValue,
            "pheromone": state.pheromone, "cremitgel": state.cremitgel, "lightTraps": state.lightTraps, "sticky": state.sticky,
            "usingofTraichogrammaCards": state.usingofTraichogrammaCards, "stemApplication": state.stemApplication,
            "regularFieldbservations": state.regularFieldbservations, "eTLlevelBasedApplication": state.eTLlevelBasedApplication,
            "alternate": state.alternate, "criticalGrowthStageIrrigation": state.criticalGrowthStageIrrigation,
            "selectedDrip": state.selectedDrip, "avoidRepititionofSamepesticides": state.avoidRepititionofSamepesticides,
            "fullbodyCoveringDress": state.fullbodyCoveringDress, "selectedDootsAndshoes": state.selectedDootsAndshoes, "selectedMaks": state.selectedMaks,
            "selectedGogglesAndHelmet": state.selectedGogglesAndHelmet, "selectedFullPPE": state.selectedFullPPE, "applicationEquipement": state.applicationEquipement,
            "selectedGloves": state.selectedGloves, "properDisposalOfChemicalContainers": state.properDisposalOfChemicalContainers, "appropriate_PPE": state.appropriate_PPE,
            "avoidChemicalSprayupto45Days": state.avoidChemicalSprayupto45Days, "trichoderma": state.trichoderma, "pseudomonas": state.pseudomonas, "beaveriaBassiana": state.beaveriaBassiana,
            "removalofrosetteflowers": state.removalofrosetteflowers, "avoidContamination": state.avoidContamination, "avoidPolyPropyleneBags": state.avoidPolyPropyleneBags,
            "useOfNanoUrea": state.useOfNanoUrea, "cropresidueManagement": state.cropresidueManagement, "reduceInterculturalOperationsAwarenessonthechildLabour": state.reduceInterculturalOperationsAwarenessonthechildLabour,
            "awarenessonMinimumwages": state.awarenessonMinimumwages, "maintainanceOfFFBs": state.maintainanceOfFFBs, "ploughAcrossTheslope": state.ploughAcrossTheslope, "biofertilizer": state.biofertilizer,
            "foodSpray": state.foodSpray, "awarenessOnTheChildLabour": state.awarenessOnTheChildLabour, "cottonGradingSafeStorage": state.cottonGradingSafeStorage, "avoidChildLabour": state.avoidChildLabour, "minimumWages": state.minimumWages,
            "agniAstra": state.agniAstra, "neemAstra": state.neemAstra, "dashaparnikashayam": state.dashaparnikashayam, "vermiWash": state.vermiWash, "usingOfCocktailsByFarmers": state.usingOfCocktailsByFarmers, "panGroupPesticides": state.panGroupPesticides,
            "monocrotophos": state.monocrotophos, "lambdaCyhalothrin": state.lambdaCyhalothrin, "carbendazim": state.carbendazim, "propiconazole": state.propiconazole, "bifenthrin": state.bifenthrin,
            "codeOfpesticides": state.codeOfpesticides, "useOfNanoUreaPotash": state.useOfNanoUreaPotash,
            "pesticidesprayingTechniques": state.pesticidesprayingTechniques, "biochar": state.biochar,

        }]
        setState((prevState) => ({ ...prevState, loading: true }));
        try {
            const params = {
                target_year_id: state.selectedYearValue,
                farmer_id: state.seleectedFarmerValue,
                adoption_report: stateDetails,
                inserted_by: user.user_id
            };

            const createSession = await createAdOption(params);
            if (createSession.statusCode === 200) {
                handleAdOption();
                setState((prevState) => ({
                    ...prevState,
                    loading: false,
                    responseMessage: createSession.message
                }));
                setTimeout(() => {
                    navigate('/adOption/history');
                }, 1000);


                setSnackbar({
                    open: true,
                    message: createSession.message,
                    severity: "success",
                });
            }
        } catch (error) {
            console.error(error);
            setSnackbar({
                open: true,
                message: error,
                severity: "success",
            });
        }
    };

    const filteredSections = useMemo(() => {
        if (!searchText) return AdOptionCreationFields;

        const search = searchText.toLowerCase();

        return AdOptionCreationFields
            .map(section => {
                // filter fields
                const filteredFields = section.fields?.filter(field =>
                    field.label?.toLowerCase().includes(search)
                );

                // filter footer fields
                const filteredFooter = section.footerData?.filter(field =>
                    field.label?.toLowerCase().includes(search)
                );

                // match section title
                const titleMatch = section.titleData?.toLowerCase().includes(search);

                if (
                    titleMatch ||
                    (filteredFields && filteredFields.length > 0) ||
                    (filteredFooter && filteredFooter.length > 0)
                ) {
                    return {
                        ...section,
                        fields: filteredFields,
                        footerData: filteredFooter,
                    };
                }

                return null;
            })
            .filter(Boolean);
    }, [searchText, AdOptionCreationFields]);

    return (
        <>
            <Divider sx={{ bgcolor: '#f5f1f1ff' }} />

            <Box mt={1}>
                <Card elevation={6}>
                    <Grid container spacing={2} p={2}>
                        {
                            [...user?.level_id === 1 ? [
                                { id: 1, label: "Select Villag", name: "selectedVillageValue", value: state.selectedVillageValue, options: villagesArray, error: state.selectedVillageValueError }
                            ] : [
                                { id: 2, label: "Select Group", name: "selectedGroupValue", value: state.selectedGroupValue, options: groupsArray, error: state.selectedGroupValueError }
                            ],
                            { id: 3, label: "Select Farmer", name: "seleectedFarmerValue", value: state.seleectedFarmerValue, options: state.villageAndGroupWiseFarmerData, error: state.seleectedFarmerValueError, disabled: state.farmersEnable },
                            { id: 4, label: "Select Year", name: "selectedYearValue", value: state.selectedYearValue, options: years, disabled: true }
                            ].map((field) => (
                                <Grid item size={{ xs: 12, md: 3 }}>
                                    <SingleSelect
                                        name={field.name}
                                        label={field.label}
                                        options={field.options || []}
                                        value={field.value}
                                        disabled={field.disabled}
                                        onChange={handleInputChange}
                                        error={field.error}
                                        formHelperText={true}
                                    />
                                </Grid>
                            ))
                        }
                    </Grid>

                    <Box mt={0}>

                        <Grid container spacing={2} sx={{
                            display: "flex", justifyContent: "flex-end", p: 0, color: clientTheme.activeTextColor,
                            backgroundColor: clientTheme.activeBg,
                        }}>
                            <Grid item size={{ xs: 12, md: 4 }} mt={1} mr={2}>
                                <TextField
                                    fullWidth
                                    size="small"
                                    type="text"
                                    placeholder="Search options..."
                                    value={searchText}
                                    onChange={(e) => setSearchText(e.target.value)}
                                    sx={{
                                        mb: 1,
                                        "& .MuiOutlinedInput-root": {
                                            backgroundColor: "#fff",
                                            color: "#000",

                                            "& fieldset": {
                                                borderColor: "transparent",
                                            },
                                            "&:hover fieldset": {
                                                borderColor: "transparent",
                                            },
                                            "&.Mui-focused fieldset": {
                                                borderColor: "transparent",
                                            },
                                        },

                                        "& .MuiInputBase-input::placeholder": {
                                            color: "#000",
                                            opacity: 0.9,
                                        },
                                    }}
                                />
                            </Grid>
                        </Grid>

                        {filteredSections.map((section, sectionIndex) => (
                            <Card key={sectionIndex} sx={{ mb: 0, m: 3, boxShadow: 6 }}>

                                {/* Card Header */}
                                {section.title && (
                                    <CardHeader
                                        sx={{
                                            backgroundColor: clientTheme.activeBg, // light green highlight
                                            borderBottom: "2px solid",
                                            borderColor: "success.main",
                                            py: 1,
                                        }}
                                        title={
                                            <Typography
                                                align="center"
                                                sx={{
                                                    textTransform: "uppercase",
                                                    fontSize: 16,
                                                    letterSpacing: "0.5px",
                                                    color: "#fff", fontWeight: "bold", textTransform: "uppercase"
                                                }}
                                            >
                                                {section.titleData}
                                            </Typography>
                                        }
                                    />
                                )}


                                {/* Card Body */}
                                <CardContent>
                                    <Grid container spacing={2}>
                                        {section?.fields?.length > 0 &&
                                            section.fields.map((field, fieldIndex) => (
                                                <Grid item size={{ xs: 12, md: 3 }} key={fieldIndex}>
                                                    <FormControl fullWidth>
                                                        <FormLabel
                                                            sx={{ textTransform: "uppercase", fontWeight: 700, mb: 1 }}
                                                        >
                                                            {field.label}
                                                        </FormLabel>

                                                        <Box
                                                            sx={{
                                                                display: "flex",
                                                                alignItems: "center",
                                                                gap: 1,
                                                            }}
                                                        >
                                                            {options
                                                                .filter(
                                                                    (option) =>
                                                                        !(field.type === "checkbox" && option.value === 0)
                                                                )
                                                                .map((option) => (
                                                                    <FormControlLabel
                                                                        key={option.value}
                                                                        control={
                                                                            field.type === "checkbox" ? (
                                                                                <Checkbox
                                                                                    checked={
                                                                                        state[field.name]?.value === option.value
                                                                                    }
                                                                                    onChange={handleChange}
                                                                                    name={field.name}
                                                                                    value={option.value}
                                                                                    color="success"
                                                                                />
                                                                            ) : (
                                                                                <Radio
                                                                                    checked={
                                                                                        state[field.name]?.value === option.value
                                                                                    }
                                                                                    onChange={handleChange}
                                                                                    name={field.name}
                                                                                    value={option.value}
                                                                                    color="success"
                                                                                />
                                                                            )
                                                                        }
                                                                        label={field.type === "checkbox" ? "" : option.label}
                                                                    />
                                                                ))}
                                                        </Box>
                                                    </FormControl>
                                                </Grid>
                                            ))}
                                    </Grid>
                                </CardContent>

                                {/* Card Footer */}
                                {section.footer && (
                                    <CardActions>
                                        <Grid container spacing={2}>
                                            {section.footerData.map((footerField, footerIndex) => (
                                                <Grid item size={{ xs: 12, md: 3 }} key={footerIndex}>
                                                    <FormControl fullWidth>
                                                        <FormLabel
                                                            sx={{ textTransform: "uppercase", fontWeight: 700, mb: 1 }}
                                                        >
                                                            {footerField.label}
                                                        </FormLabel>

                                                        <Box sx={{ display: "flex", gap: 1 }}>
                                                            {options.map((option) => (
                                                                <FormControlLabel
                                                                    key={option.value}
                                                                    control={
                                                                        footerField.type === "checkbox" ? (
                                                                            <Checkbox
                                                                                checked={
                                                                                    state[footerField.name]?.value === option.value
                                                                                }
                                                                                onChange={handleChange}
                                                                                name={footerField.name}
                                                                                value={option.value}
                                                                                color="success"
                                                                            />
                                                                        ) : (
                                                                            <Radio
                                                                                checked={
                                                                                    state[footerField.name]?.value === option.value
                                                                                }
                                                                                onChange={handleChange}
                                                                                name={footerField.name}
                                                                                value={option.value}
                                                                                color="success"
                                                                            />
                                                                        )
                                                                    }
                                                                    label={option.label}
                                                                />
                                                            ))}
                                                        </Box>
                                                    </FormControl>
                                                </Grid>
                                            ))}
                                        </Grid>
                                    </CardActions>
                                )}
                            </Card>
                        ))}
                    </Box>

                    <CardActions sx={{ justifyContent: "center", mb: 1, mt: 1 }}>
                        <CustomButton
                            status={state.loading === true ? "loading" : "idle"}
                            onClick={handleSubmit}
                            label=" Create Plan"
                            loadingLabel="Submitting.."
                        />
                    </CardActions>
                </Card>


                <SnackbarMessage
                    open={snackbar.open}
                    message={snackbar.message}
                    severity={snackbar.severity}
                    onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
                />
            </Box>
        </>
    );
}
export default AdOptionCreation;